// @flow
import * as React from 'react';

import { Base, type DialogStateProps } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { selectPlaceholders } from '../../modules/selectors/placeholders';
import {
  selectProvidedFQDNs,
  selectProvidedResultsByAvailability,
} from '../../modules/selectors/results';
import { selectSearchValue } from '../../modules/selectors/search';

import PlaceholderList from './Placeholder/PlaceholderList';
import { ProvidedDomainList } from './ProvidedDomainList';
import { selectShowBulk } from './modules';

type Props = {
  phasesDialogState: DialogStateProps,
  isBulkLoading: boolean,
  setBulkLoading: React.ReactSetStateFunction<boolean>,
};

export function ProvidedArea({
  phasesDialogState,
  isBulkLoading,
  setBulkLoading,
}: Props): React.MixedElement | null {
  const searchValue = useAppSelector(selectSearchValue);
  const placeholders = useAppSelector(state => selectPlaceholders(state, true)); // true for provided

  const suggestions = useAppSelector(selectProvidedFQDNs);
  const showBulk = useAppSelector(selectShowBulk);

  const { available, unavailable } = useAppSelector(
    selectProvidedResultsByAvailability,
  );

  const values = React.useMemo(() => searchValue.split(' '), [searchValue]);

  if (!searchValue && !suggestions.length && !showBulk) return null;

  const showPlaceholders = placeholders > 0;
  const showList = available.length > 0 || unavailable.length > 0;

  if (showPlaceholders) {
    return (
      <Base marginBottom="base">
        <PlaceholderList searchValues={values} />
      </Base>
    );
  }

  return showBulk || showList ? (
    <ProvidedDomainList
      phasesDialogState={phasesDialogState}
      isBulkLoading={isBulkLoading}
      setBulkLoading={setBulkLoading}
    />
  ) : null;
}
